import { render, staticRenderFns } from "./Rail-Admin.vue?vue&type=template&id=c3624dd4&scoped=true"
import script from "./Rail-Admin.js?vue&type=script&lang=js&external"
export * from "./Rail-Admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3624dd4",
  null
  
)

export default component.exports